const constantsRedline = {
  RL_TRACK_CID: 'RL_TRACK_CID',
  rl_tracks_auth: 'rl_tracks_auth',
};

export default constantsRedline;
